export function percentageDifference(previousValue, currentValue) {
    // A = |𝑉1−𝑉2| / [(𝑉1+𝑉2)2] × 100
    var AlphaValue = Math.abs(previousValue - currentValue);
    var EpsilonValue = (previousValue + currentValue) / 2;
    var normalizedValue = AlphaValue / EpsilonValue;
    return Math.round(normalizedValue * 100);
}
export function randomNumber(from, to) {
    if (from === void 0) { from = 2600; }
    if (to === void 0) { to = 4600; }
    return Math.max(Math.floor(Math.random() * to), from);
}
export function roundToNearestIncrement(value, increment) {
    var justUnderHalf = increment / 2 - 0.1;
    return Math.round((value + justUnderHalf) / increment) * increment;
}
export function skillScoreRounding(score) {
    var scoreString = score === null || score === void 0 ? void 0 : score.toFixed(1);
    if (scoreString === null || scoreString === void 0 ? void 0 : scoreString.endsWith('.0'))
        return Math.round(score);
    return parseFloat(scoreString);
}
export function formattedPercentage(numerator, denominator, places) {
    if (places === void 0) { places = 0; }
    var decimal = numerator / denominator;
    var percentageValue = (decimal * 100).toFixed(places);
    return "".concat(percentageValue, "%");
}
